import LabeledTextField from '@common/ui/LabeledTextField';
import { CustomField, RequestCustomFields } from './RequestCustomFields';
import { FormState } from '@MyRequests/helpers';
import { DurationCombobox } from '@NewRequest/components/DurationCombobox.tsx';
import { useDryRunAccessRequest } from '@NewRequest/hooks/use-dry-run-access-request.ts';
import { isFormPartiallyFull } from '@NewRequest/utils/helpers.ts';
import { useCallback, useEffect } from 'react';

export function RequestFields({
  formState,
  updateFormState,
  withDuration,
  onDryRunErrorsChange,
}: {
  formState: FormState;
  updateFormState: (field: keyof FormState, value: string | CustomField | number | null) => void;
  withDuration?: boolean;
  onDryRunErrorsChange?: (isDryRunErrors: boolean) => void;
}) {
  const { durationErrorMessage, isDryRunErrors, showDuration } = useDryRunAccessRequest({ formState, withDuration });

  useEffect(() => {
    if (onDryRunErrorsChange) onDryRunErrorsChange(!!isDryRunErrors);
  }, [isDryRunErrors, onDryRunErrorsChange]);

  const handleDurationValue = useCallback(
    (value: string) => {
      const durationInSeconds = value ? parseFloat(value) * 3600 : null;
      updateFormState('selectedDuration', durationInSeconds);
    },
    [updateFormState],
  );

  return (
    <>
      {showDuration && withDuration && (
        <DurationCombobox
          onChange={handleDurationValue}
          errorMessage={durationErrorMessage}
          disable={!isFormPartiallyFull(formState)}
        />
      )}
      <LabeledTextField
        multiline
        size="small"
        minRows={2}
        label="Justification"
        value={formState.justification}
        onChange={(e) => updateFormState('justification', e.target.value)}
        placeholder="Enter justification"
        id="justification"
      />
      <RequestCustomFields onChange={(e) => updateFormState('custom_fields', e)} />
    </>
  );
}
